export * from './date'
import _ from 'lodash'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ParseJson = <T>(value: any): T | undefined => {
  switch (typeof value) {
    case 'string': // JSON 안되기도 함
      try {
        return JSON.parse(value) as T
      } catch {
        // SyntaxError:Unexpected end of JSON input
        // SyntaxError:Unexpected token 'q', "q2" is not valid JSON
        return value as T
      }
    case 'object':
    case 'undefined': // 안됨
      return value as T
    case 'boolean': //됨
    case 'number': // 됨
      return JSON.parse(JSON.stringify(value)) as T
  }
}

export const includeCDN = (url: string): boolean => {
  return url.includes('https://homecheck.kr/cdn')
}

export const getUnixtime = (): number => {
  return parseInt(`${Date.now()}`.slice(0, 10))
}
// 2025-10-13 16:31:34 형식을 unixtime으로 변환
// 서버에서 받은 시간은 로컬 시간대(KST)로 가정
export const getUnixtimeFromString = (dateString: number | string): number => {
  if (typeof dateString === 'number') {
    return dateString
  }

  // 서버 API가 KST 시간에 .000Z를 붙여서 보내는 문제 대응
  // "2025-10-30T10:36:09.000Z" 형식이 실제로는 KST 시간임
  if (dateString.includes('.000Z')) {
    // .000Z를 제거하고 로컬 시간대(KST)로 파싱
    const withoutZ = dateString.replace('.000Z', '')
    const date = new Date(withoutZ)
    return Math.floor(date.getTime() / 1000)
  }

  // 일반적인 ISO 8601 형식 (T 또는 Z 포함)
  if (dateString.includes('T') || dateString.includes('Z')) {
    const date = new Date(dateString)
    return Math.floor(date.getTime() / 1000)
  }

  // "YYYY-MM-DD HH:MM:SS" 형식은 로컬 시간대로 파싱
  // 서버가 KST로 저장하므로 로컬 시간대(KST)로 해석
  const date = new Date(dateString.replace(' ', 'T'))

  return Math.floor(date.getTime() / 1000)
}
export const getRandomString = (length: number, withCharacter: boolean): string => {
  const charsNumber = '0123456789'
  const charsLower = 'abcdefghijklmnopqrstuvwxyz'
  const charsUpper = 'ABCDEFGHIJKLMNOPQRSTUVWXTZ'
  const charsSpecial = '!@#$%^&*()-_=+,<.>?|'
  let charsAll = [charsNumber, charsLower, charsUpper] //  Include special character by default but allow checkbox to toggle option
  if (withCharacter) {
    //  Evaluate checkbox status
    charsAll = [charsNumber, charsLower, charsUpper, charsSpecial]
  }
  const chars = charsAll.join('')
  let randomString = ''
  for (let i = 0; i < length; i++) {
    // Get string length
    const randNum = Math.floor(Math.random() * chars.length) // and then
    randomString += chars.substring(randNum, randNum + 1) // randomize it
  }

  return randomString
}

export const formatBytes = (bytes: number, decimals: number = 2): string => {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
